import { CommonModule, DOCUMENT } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, inject, Inject, Input, OnInit, Optional, Renderer2 } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { RequestService } from '@df/api/request/request.service';
import { ProductListingFactory } from '@df/catalog-ui/listing/product-listing.factory';
import { Product as CoreProduct, IProductDataV2 } from '@df/catalog/product/product';
import { App } from '@df/core/app';
import { Meta } from '@df/core/meta/meta';
import { GtmService } from '@df/module-gtm/gtm.service';
import { ImageModule } from '@df/module-image/image.module';
import { KlevuSearchService } from '@df/module-klevu-search/klevu-search.service';
import { OffClickModule } from '@df/module-off-click/off-click.module';
import { TimeoutService } from '@df/ng/timeout.service';
import { NSearch } from '@df/search/df-search.config';
import { SearchComponentDef } from '@df/search/search.component.def';
import { Search } from '@df/search/search.interfaces';
import { CarouselModule } from '@df/ui-carousel/carousel.module';
import { GridModule } from '@df/ui/atomic/atom/grid/grid.module';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { Product } from '../../catalog/product/product.decorator';
import { ProductComponent } from '../../catalog/product/product/product.component';
import { LocalGtmService } from '../../module/gtm/gtm.service.decorator';
import { ShellComponent } from '../../ui/display/local-shell.component';
import { IOffCanvasSearchTrayModalBlockDataContent, OffCanvasSearchTrayModalComponent } from './off-canvas-search-tray-modal.component';
import { SearchBannerComponent } from './search-banner.component';
import { SearchLinksComponent } from './search-links.component';
@Component({
    selector: 'off-canvas-search-tray',
    templateUrl: './off-canvas-search-tray.html',
    standalone: true,
    imports: [
        SearchBannerComponent,
        SearchLinksComponent,
        CommonModule,
        FormsModule,
        OffClickModule,
        ProductComponent,
        GridModule,
        ProductComponent,
        TranslationModule,
        RouterLink,
        ImageModule,
        ShellComponent,
        HrefComponent,
        CarouselModule
    ]
})
export class OffCanvasSearchTrayComponent extends SearchComponentDef implements OnInit, AfterViewInit {
    @Input()
    contentBlockData?: IOffCanvasSearchTrayModalBlockDataContent;

    constructor(
        override readonly app: App,
        @Inject(DOCUMENT) protected override document: Document,
        protected override router: Router,
        protected override searchService: KlevuSearchService,
        protected override renderer2: Renderer2,
        requestService: RequestService,
        protected override meta: Meta,
        protected override timeoutService: TimeoutService,
        productListingFactory: ProductListingFactory,
        protected override _ref: ChangeDetectorRef,
        @Inject(NSearch.OPTIONS) config: NSearch.IModuleOptions,
        @Optional() private offCanvasSearchTrayModalComponent: OffCanvasSearchTrayModalComponent
    ) {
        super(app, document, router, searchService, renderer2, requestService, meta, timeoutService, productListingFactory, _ref, config);
    }

    private gtmService = inject(GtmService) as LocalGtmService;

    override ngOnInit(): void {
        super.ngOnInit();
        this.searchService.loadKlevuVars(() => this._ref.detectChanges());
        this.subscriptions.add(this.status.subscribe(() => this.detectChanges()));
        this.subscriptions.add(this.searchService.subscribeToSearch(() => this.detectChanges()));
        this.gtmService.searchDesign = 'search_icon';
    }
    override ngOnDestroy(): void {
        super.ngOnDestroy();
        this.gtmService.searchDesign = undefined;
        this.reset();
    }
    ngAfterViewInit(): void {
        this.isFocus = true;
    }
    get popularTerms() {
        return this.searchService.webstorePopularTerms;
    }
    keyup(event: KeyboardEvent): void {
        if (event.key === 'Enter' || event.code === 'Enter') {
            this.input?.nativeElement.blur();
            this.goToSearch();
        }
    }
    trackByTerm(index: number, term: Search.ITerm): string {
        return term.phrase;
    }
    close() {
        this.offCanvasSearchTrayModalComponent?.close();
    }

    asLocalProduct(product: CoreProduct<IProductDataV2>): Product<IProductDataV2> {
        return product as Product<IProductDataV2>;
    }
}
